import { useQuery } from '@tanstack/react-query'
import { MpxTypeaheadAPI, MpxTypeaheadQuery } from '@cibo/core'

export const useTypeaheadSuggestions = (query: MpxTypeaheadQuery) => {
  return useQuery(
    ['typeahead', JSON.stringify(query)],
    () => {
      return MpxTypeaheadAPI.suggest(query).then(results => results.items)
    },
    {
      enabled: !!query && query.searchText !== '',
    }
  )
}
